import { PayloadAction } from '@reduxjs/toolkit';

import { ReportsState } from '../../types';

export const setUnauthorizedReportDownloadStatus = (
  state: ReportsState,
  action: PayloadAction<ReportsState['unauthorizedReport']['downloadStatus']>,
) => {
  state.unauthorizedReport.downloadStatus = action.payload;
};
